import React from 'react';
import ExternalDoorsIframeModal from './ExternalDoorsIframeModal';

interface AccessManagementProps {
    onClose: () => void;
}

const AccessManagement: React.FC<AccessManagementProps> = ({ onClose }) => {
    return <ExternalDoorsIframeModal onClose={onClose} urlPath="" title="Access Management" />;
};

export default AccessManagement;
